import { useEffect } from 'react';
import OrchestratorDashboard from '@/components/OrchestratorDashboard';

/**
 * Agents page — for now, surfaces only the Orchestrator agent.
 * Other agents (Email, Call, Marketing, etc.) are intentionally hidden;
 * the orchestrator coordinates all of them under the hood.
 */
export default function AgentsHub() {
  useEffect(() => {
    document.title = 'Orchestrateur - Reno Resolve';
  }, []);

  return <OrchestratorDashboard />;
}
